// extracted by mini-css-extract-plugin
export default {"container":"TemplateRenderer_container__qTWmu","editContainer":"TemplateRenderer_editContainer__Bzhih"};